import { translatedUrlState } from '@application/state';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

export const useTranslatedUrl = (
  translations?:
    | {
        language: string;
        url?: string | null;
      }[]
    | null,
) => {
  const [state, setState] = useRecoilState(translatedUrlState);

  useEffect(() => {
    return () => {
      setState({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let params;
    // eslint-disable-next-line no-restricted-syntax
    for (const translation of translations ?? []) {
      params = { ...(params ?? {}), [translation.language]: translation.url };
    }
    if (params) {
      setState({ ...params });
    }
  }, [translations, setState]);
};
